//------------------------------------------------------------------------------
// マスター情報 リデューサー
//------------------------------------------------------------------------------
import { combineReducers } from 'redux';
import types from './types';

/**
 * 汎用マスタ更新
 */
const genericMap = (state = null, action) => {
  return (action.type === types.GENERIC)
      ? action.genericMap
      : state;
};

/**
 * 地区マスタ
 */
const areaList = (state = null, action) => {
  return (action.type === types.AREAS)
      ? action.areaList ?? null
      : state;
};

/**
 * マスタ取得状態
 */
const loaded = (state = false, action) => {
  return (action.type === types.LOADED)
      ? action.loaded ?? false
      : state;
};

// エクスポート
const reducers = combineReducers({
  genericMap,
  areaList,
  loaded,
});
export default reducers;
